import styled from 'styled-components'

export const StylePortfolioGridItem = styled.div<{ portBg?: string }>`
  border: 0;
  border-radius: 0;
  box-shadow:
    1px 0 0 0 #ffffff,
    0 1px 0 0 #ffffff,
    1px 1px 0 0 #ffffff,
    1px 0 0 0 #ffffff inset,
    0 1px 0 0 #ffffff inset;
  transition: all 0.2s;
  height: 100%;
  &:hover {
    background-color: ${(props) => (props.portBg ? props.portBg : '#fff')};
    .title-inner {
      h2 {
        color: #fff !important;
      }
    }
  }
`
